import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { get, omit } from 'lodash';
import { defaultLang } from 'src/app/shared/constants';
@Component({
  selector: 'app-formly-text-content',
  templateUrl: './text-content.component.html',
})
export class FormlyFieldTextContentComponent extends FieldType<FormlyFieldConfig> implements OnInit, AfterViewChecked {
  @ViewChild('textContent', { static: true }) textContent: ElementRef;
  html = '';
  constructor(
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngAfterViewChecked(): void {
    const matFormField = this.textContent.nativeElement.closest('.mat-form-field-wrapper');
    const underlineElement = matFormField ? matFormField.querySelector('.mat-form-field-underline') : null;
    if (underlineElement) {
      underlineElement.style.display = 'none';
    }
  }

  ngOnInit() {
    const templateOptions = get(this, 'field.templateOptions');
    if (templateOptions) {
      this.field.templateOptions = omit(templateOptions, 'label');   
    }
    const userLang = navigator.language.toString().toLocaleLowerCase();
    const content = get(this, `field.templateOptions.i18n_html.${userLang}`,
      get(this, `field.templateOptions.i18n_html.${defaultLang}`, ''));
    this.html = content;
    if (content) {
      this.formControl.setValue(content);
      this.cdr.markForCheck();
    }
  }
}
